import { closeImage } from 'app/stores/image/actions/close';
import { downloadImage } from 'app/stores/image/actions/download';
import { loadImageFile, loadImageFiles } from 'app/stores/image/actions/load';
import { parseImageData } from 'app/stores/image/actions/parse';
import { persistImage } from 'app/stores/image/actions/persist';
import { restoreImage } from 'app/stores/image/actions/restore';
export const ImageActions = {
    persistImage,
    restoreImage,
    parseImageData,
    downloadImage,
    loadImageFile,
    loadImageFiles,
    closeImage,
};
